(function($, window) {
  "use strict";
  const header = document.querySelector(".header");
  const navWrapper = document.querySelector(".header__nav-wrapper");

  DSV.ui.header = {
    fixedHeader() {
      const pageScroll = window.pageYOffset;
      const pageTop = 0;

      if (pageScroll > pageTop) {
        header.classList.add("header--fixed");
      } else {
        header.classList.remove("header--fixed");
      }
    },

    setMobileHeight() {
      const headerHeight = 80;
      const isMobileOnly = document.documentElement.clientWidth < 560;

      if (isMobileOnly) {
        navWrapper.style.height = window.innerHeight - headerHeight + "px";
      } else {
        navWrapper.style.height = window.innerHeight + "px";
      }
    },

    toggleMobileNav() {
      const navTrigger = document.querySelector(".nav__trigger--open");
      const navClose = document.querySelector(".nav__trigger--close");

      navTrigger.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          if (!document.body.classList.contains("nav-open")) {
            TweenLite.to(navWrapper, 0.3, {
              x: "0%",
              clearProps: "x",
              onStart: function() {
                header.classList.add("trigger--open");
              },
              onComplete: function() {
                document.body.classList.add("nav-open");
              },
            });
          } else {
            TweenLite.to(navWrapper, 0.3, {
              x: "110%",
              clearProps: "x",
              onStart: function() {
                header.classList.remove("trigger--open");
              },
              onComplete: function() {
                document.body.classList.remove("nav-open");
              },
            });
          }
        },
        false
      );

      navClose.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          TweenLite.to(navWrapper, 0.3, {
            x: "110%",
            clearProps: "x",
            onStart: function() {
              header.classList.remove("trigger--open");
            },
            onComplete: function() {
              document.body.classList.remove("nav-open");
            },
          });
        },
        false
      );
    },

    //Prevent checking evering single scroll
    throttle(delay, fn) {
      let lastCall = 0;
      return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return fn(...args);
      };
    },

    // Check last scroll event
    debounce(delay, fn) {
      let timerId;
      return function(...args) {
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
          fn(...args);
          timerId = null;
        }, delay);
      };
    },

    setup() {
      //Mobile menu is active from 0 - 1024px window width. 1024px included
      const isMobileMenu =
        DSV.tools.screenMode.currentMode < DSV.tools.screenSizes.desktop + 1 ||
        window.innerWidth === 1024;

      if (isMobileMenu) {
        this.setMobileHeight();
        this.toggleMobileNav();
      } else {
        this.fixedHeader();
        TweenLite.set(navWrapper, { clearProps: "all" });
      }
    },

    resizeHandler() {
      const debounce = this.debounce(100, () => this.setup());
      window.addEventListener("resize", () => debounce());
    },

    init() {
      this.setup();
      this.resizeHandler();

      window.addEventListener("scroll", this.throttle(300, this.fixedHeader));
      window.addEventListener("scroll", this.debounce(300, this.fixedHeader));
    },
  };
})(jQuery, window);
